import { AutogenModelCallListProfile, AutogenRowCallListProfile } from "./autogen/AutogenModelCallListProfile";

export class ModelCallListProfile extends AutogenModelCallListProfile<RowCallListProfile> {
	constructor() {
		super(RowCallListProfile);
	}
}

export class RowCallListProfile extends AutogenRowCallListProfile {
}